
let editors = {
    dropDownList(selectList, valField) {
        //valField is return what value 
        let func = function (args) {
            var $select;
            var $input;
            var defaultValue;
            var scope = this;
            let options = "";


            selectList.forEach(select => {
                options += `<OPTION value='${select.Value}'>${select.Key}</OPTION>`;
            })

            this.init = function () {

                $select = $(`<SELECT tabIndex='0' class='editor-customList'>${options}</SELECT>`);
                $select.appendTo(args.container);
                $select.focus();
            };

            this.destroy = function () {
                $select.remove();
            };

            this.focus = function () {
                $select.focus();
            };

            this.loadValue = function (item) {
                defaultValue = item[args.column.field];
                $select.val(defaultValue);
                $select.select();
            };

            this.serializeValue = function () {
                return $select.val();
            };

            this.applyValue = function (item, state) {
                console.log(item);
                item[args.column.field] = $select.children(":selected").text();
                if (state != null && state != undefined) {
                    item[valField] = state
                } else {
                    console.warn(valField)
                }
            };

            this.isValueChanged = function () {
                return ($select.val() != defaultValue);
            };

            this.validate = function () {
                return {
                    valid: true,
                    msg: null
                };
            };

            this.init();
        }

        return func;
    },

    select2List(selectList, valField) {
        let func = function (args) {
            if (!valField) {
                valField = args.column.field;
            }
            var $select;
            var defaultValue;
            var scope = this;
            let options = "";
            selectList.forEach(select => {
                options += `<OPTION value='${select.Value}'>${select.Key}</OPTION>`;
            })

            this.init = function () {

                $select = $(`<SELECT tabIndex='0' class='select2' style="width:100%">${options}</SELECT>`);
                $select.appendTo(args.container);
                $select.select2();
                $select.focus();
            };

            this.destroy = function () {
                $select.remove();
            };

            this.focus = function () {
                $select.focus();
            };

            this.loadValue = function (item) {
                defaultValue = item[args.column.field];
                $select.val(defaultValue);
                $select.select();
            };

            this.serializeValue = function () {
                return $select.val();
            };

            this.applyValue = function (item, state) {
                item[args.column.field] = $select.children(":selected").text();
                if (state != null && state != undefined) {
                    item[valField] = state
                } else {
                    console.warn(valField)
                }
            };

            this.isValueChanged = function () {
                return ($select.val() != defaultValue);
            };

            this.validate = function () {
                return {
                    valid: true,
                    msg: null
                };
            };

            this.init();
        }

        return func;
    },

    select2TagsList(selectList, valField) {
        let func = function (args) {
            if (!valField) {
                valField = args.column.field;
            }

            let formatOption = (option) => {
                 let title = option.title||"";
                var $option = $(
                    "<div><strong>" +
                    option.text +
                    "</strong></div>" +
                    title +
                    "</div>"
                );
                return $option;
            }

            let matchCustom = (params, data) => {
                if ($.trim(params.term) === "") {
                    return data;
                }
                let dataTitle = data.title||"";
                let check = (v1, v2) =>  v1.toUpperCase().includes(v2.toUpperCase());
                if (check(data.text, params.term) || check(dataTitle, params.term)) {
                    return data;
                }

                return null;
            }

            var $select;
            var defaultValue;
            var scope = this;
            let options = "";
            selectList.forEach(select => {
                options += `<OPTION value='${select.Value}' title="${select.title}">${select.Key}</OPTION>`;
            })

            this.init = function () {

                $select = $(`<SELECT tabIndex='0' multiple="multiple" class='select2' style="width:100%">${options}</SELECT>`);
                $select.appendTo(args.container);
                $select.select2({
                    tags:true,
                    // allowClear: true,
                    width: 'resolve',
                    templateResult: formatOption,
                    matcher: matchCustom
                });
                $select.focus();
            };

            this.destroy = function () {
                $select.remove();
            };

            this.focus = function () {
                $select.focus();
            };

            this.loadValue = function (item) {
                defaultValue = item[args.column.field];
                $select.val(defaultValue);
                $select.select();
            };

            this.serializeValue = function () {
                return $select.val();
            };

            this.applyValue = function (item, state) {
                console.log(item);
                item[args.column.field] = $select.children(":selected").text();
                if (state != null && state != undefined) {
                    item[valField] = state
                } else {
                    console.warn(valField)
                }
            };

            this.isValueChanged = function () {
                return ($select.val() != defaultValue);
            };

            this.validate = function () {
                return {
                    valid: true,
                    msg: null
                };
            };

            this.init();
        }

        return func;
    },

    TextEditor(args) {
        var $input;
        let defaultValue;

        this.init = function () {
            $input = $("<INPUT type=text class='editor-text' />")
                .appendTo(args.container)
                .on('keydown.nav', function (e) {
                    // if (e.keyCode === keyCode.LEFT || e.keyCode === keyCode.RIGHT) {
                    //     e.stopImmediatePropagation();
                    // }
                })
                .focus()
                .select();
        };

        this.destroy = function () {
            $input.remove();
        };

        this.focus = function () {
            $input.focus();
        };

        this.getValue = function () {
            return $input.val();
        };

        this.setValue = function (val) {
            $input.val(val);
        };

        this.loadValue = function (item) {
            defaultValue = item[args.column.field] || '';
            $input.val(defaultValue);
            $input[0].defaultValue = defaultValue;
            $input.select();
        };

        this.serializeValue = function () {
            return $input.val();
        };

        this.applyValue = function (item, state) {
            item[args.column.field] = state;
        };

        this.isValueChanged = function () {
            return (!($input.val() == '' && defaultValue == null)) && ($input.val() != defaultValue);
        };

        this.validate = function () {
            let valid = true;
            let msg = null;
            if (args.column.validator) {
                let validationResults = args.column.validator($input.val(), args);
                valid = validationResults.valid;
                msg = validationResults.msg;
            }

            return {
                valid: true,
                msg: null
            };
        };

        this.init();
    },

    DateTimeEditor(args) {
        var $input;
        var defaultValue;
        var scope = this;
        var calendarOpen = false;

        this.init = function () {
            $input = $("<INPUT type=text class='editor-text' />");

            // $input.bind("keydown.nav", function (e) {
            //     if (e.keyCode === $.ui.keyCode.LEFT || e.keyCode === $.ui.keyCode.RIGHT) {
            //         e.stopImmediatePropagation();
            //     }
            // });

            $input.appendTo(args.container);

            $input.daterangepicker(
                {
                    locale: {
                        format: "YYYY-MM-DD"
                    },
                    autoApply: false,
                    singleDatePicker: true,
                    autoUpdateInput: false,
                    minDate: "2000-01-01",
                    showDropdowns: true,
                    // maxDate: `${parseInt(moment().format("YYYY"), 10)}-12-31`
                },
            )
                .on("apply.daterangepicker", function (e, picker) {
                    let date = picker.startDate.format('YYYY-MM-DD');
                    $input.val(date);

                })
                .on("hide.daterangepicker", function (e, picker) {
                    calendarOpen = false;
                })
                .on("show.daterangepicker", function (e, picker) {
                    calendarOpen = true;
                })

            $input.focus().select();
            $input.width($input.width() - 18);
        };

        this.destroy = function () {
            // $.datepicker.dpDiv.stop(true, true);
            // $input.datepicker("hide");
            // $input.datepicker("destroy");

            $input.data('daterangepicker').hide();
            $input.remove();
        };

        this.show = function () {
            if (calendarOpen) {
                // $.datepicker.dpDiv.stop(true, true).show();
            }
        };

        this.hide = function () {
            if (calendarOpen) {
                // $.datepicker.dpDiv.stop(true, true).hide();
            }
        };

        this.position = function (position) {
            if (!calendarOpen) {
                return;
            }
            // $.datepicker.dpDiv
            //     .css("top", position.top + 30)
            //     .css("left", position.left);
        };

        this.focus = function () {
            $input.focus();
        };

        this.loadValue = function (item) {

            var tempDate = item[args.column.field];

            if ((tempDate != undefined) && (tempDate.getMonth))
                defaultValue = item[args.column.field].toString('yyyy-MM-dd HH:mm:ss');

            //defaultValue = item[args.column.field];


            $input.val(defaultValue);
            $input[0].defaultValue = defaultValue;
            $input.select();
        };

        this.serializeValue = function () {
            return moment($input.val()).format("YYYY-MM-DD");
        };

        this.applyValue = function (item, state) {
            item[args.column.field] = state;
        };

        this.isValueChanged = function () {
            return (!($input.val() == "" && defaultValue == null)) && ($input.val() != defaultValue);
        };

        this.validate = function () {

            try {
                if (moment($input.val()).format("YYYY-MM-DD") == "Invalid date") {
                    alert("DateTime must be in format: yyyy-MM-dd");
                    return {
                        valid: false,
                        msg: "DateTime must be in format: yyyy-MM-dd"
                    };
                }
                else {
                    return {
                        valid: true,
                        msg: null
                    };
                }
            }
            catch (ex) {
                console.log(ex.message)
            }


        };

        this.init();
    },

    NumericEditor(args) {
        var $input;
        var defaultValue;
        var scope = this;

        this.init = function () {
            $input = $("<INPUT type=text class='editor-text' />");

            $input.bind("keydown.nav", function (e) {
                // if (e.keyCode === $.ui.keyCode.LEFT || e.keyCode === $.ui.keyCode.RIGHT) {
                //     e.stopImmediatePropagation();
                // }
            });

            $input.appendTo(args.container);
            $input.focus().select();
        };

        this.destroy = function () {
            $input.remove();
        };

        this.focus = function () {
            $input.focus();
        };

        this.loadValue = function (item) {
            defaultValue = item[args.column.field];
            $input.val(defaultValue);
            $input[0].defaultValue = defaultValue;
            $input.select();
        };

        this.serializeValue = function () {
            return parseFloat($input.val()) || 0;
        };

        this.applyValue = function (item, state) {
            item[args.column.field] = state;
        };

        this.isValueChanged = function () {
            return (!($input.val() == "" && defaultValue == null)) && ($input.val() != defaultValue);
        };

        this.validate = function () {
            if (isNaN($input.val())) {
                alert("Please enter a valid number.")
                return {
                    valid: false,
                    msg: "Please enter a valid number."
                };
            }

            return {
                valid: true,
                msg: null
            };
        };

        this.init();
    },

    CheckboxEditor(args) {
        let $select;
        let defaultValue;
        let scope = this;

        this.init = function () {
            $select = $("<INPUT type=checkbox value='true' class='editor-checkbox' hideFocus>");
            $select.appendTo(args.container);
            $select.focus();
        };

        this.destroy = function () {
            $select.remove();
        };

        this.focus = function () {
            $select.focus();
        };

        this.loadValue = function (item) {
            defaultValue = !!item[args.column.field];
            if (defaultValue) {
                $select.prop('checked', true);
            } else {
                $select.prop('checked', false);
            }
        };

        this.serializeValue = function () {
            return $select.prop('checked');
        };

        this.applyValue = function (item, state) {
            item[args.column.field] = state;
        };

        this.isValueChanged = function () {
            return (this.serializeValue() !== defaultValue);
        };

        this.validate = function () {
            let valid = true;
            let msg = null;
            if (args.column.validator) {
                let validationResults = args.column.validator($select.val(), args);
                valid = validationResults.valid;
                msg = validationResults.msg;
            }

            return {
                valid: true,
                msg: null
            };
        };

        this.init();
    }


}




export default editors;


